import React from "react";
import Meta from "../components/Meta";
import LongContent from "../components/LongContent";

function LegalMobilePage(props) {
  return (
    <>
      <Meta title="showNAV | Legal" />
      <div style={{marginLeft: '10%', marginRight: '10%'}}>
      <LongContent>
      <h1>Privacy Policy</h1>
          <p><strong>Effective Date:</strong> August 29, 2025</p>

          <p>ShowNAV Inc. ("we," "our," or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use the <strong>showNAV</strong> mobile application ("App").</p>

          <h2>1. Information We Collect</h2>
          <ul>
            <li><strong>Email Address:</strong> Collected when you create an account to use the App.</li>
            <li><strong>Usage Data:</strong> Information such as how you interact with the App, collected via Google Analytics.</li>
          </ul>
          <p>We do not collect payment information, location data, contacts, photos, or other personal details.</p>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Create and manage your account.</li>
            <li>Provide and improve our services.</li>
            <li>Analyze usage trends and improve app performance through Google Analytics.</li>
          </ul>

          <h2>3. Third-Party Services</h2>
          <p>Our App uses the following third-party services:</p>
          <ul>
            <li><strong>Google Maps:</strong> Used to search for and open locations. When you select a location, you may be redirected to the Google Maps app. Use of Google Maps is subject to <a href="https://policies.google.com/privacy" target="_blank">Google’s Privacy Policy</a>.</li>
            <li><strong>Google Analytics:</strong> Used to understand app usage and improve performance.</li>
          </ul>
          <p>We do not control how these third-party services collect or use data, so we encourage you to review their privacy policies.</p>

          <h2>4. Data Sharing</h2>
          <p>We do not sell, rent, or share your personal information with third parties. Your data is only stored and processed through the third-party services described above.</p>

          <h2>5. Data Security</h2>
          <p>We use reasonable measures to protect your data. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

          <h2>6. Your Choices</h2>
          <ul>
            <li>You may request deletion of your account and associated data at any time by contacting us at the email below.</li>
            <li>You may opt out of certain analytics features through your device settings.</li>
          </ul>

          <h2>7. Children’s Privacy</h2>
          <p>Our App is not directed to children under the age of 13. We do not knowingly collect personal information from children.</p>

          <h2>8. Availability</h2>
          <p>This App is intended for users in the United States.</p>

          <h2>9. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. If we make material changes, we will notify you by updating the "Effective Date" above and, where appropriate, within the App.</p>

          <h2>10. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>ShowNAV Inc.</strong><br></br>
          Email: <a href="mailto:admin@shownav.net">admin@shownav.net</a></p>
    </LongContent>
    </div>
    </>
  );
}

export default LegalMobilePage;
